/**
 * BAS Automation - Theme JavaScript
 * Handles cart functionality, mobile menu, and interactive elements
 */

(function() {
  'use strict';

  // ===================================
  // Mobile Menu Toggle
  // ===================================
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const navMenu = document.querySelector('.nav-menu');
  
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function() {
      navMenu.classList.toggle('active');
      this.classList.toggle('active');
    });
  }

  // Close mobile menu when clicking outside
  document.addEventListener('click', function(e) {
    if (navMenu && navMenu.classList.contains('active')) {
      if (!e.target.closest('.nav-menu') && !e.target.closest('.mobile-menu-toggle')) {
        navMenu.classList.remove('active');
        if (mobileMenuToggle) {
          mobileMenuToggle.classList.remove('active');
        }
      }
    }
  });

  // ===================================
  // Header Scroll Effect
  // ===================================
  const header = document.querySelector('.site-header');
  
  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });

  // ===================================
  // Cart Drawer
  // ===================================
  const cartIcon = document.querySelector('.cart-icon');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartClose = document.querySelector('.cart-close');

  function openCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('active');
      cartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('active');
      cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (cartIcon) {
    cartIcon.addEventListener('click', openCart);
  }

  if (cartClose) {
    cartClose.addEventListener('click', closeCart);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }

  // ===================================
  // Add to Cart Functionality
  // ===================================
  function addToCart(variantId, quantity = 1, callback) {
    const formData = {
      items: [{
        id: variantId,
        quantity: quantity
      }]
    };

    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      updateCartUI();
      
      // Only open cart if no callback provided
      if (!callback) {
        openCart();
      }
      
      showNotification('Product added to cart!', 'success');
      
      // Execute callback if provided
      if (callback && typeof callback === 'function') {
        callback(data);
      }
    })
    .catch(error => {
      console.error('Error:', error);
      showNotification('Failed to add product to cart', 'error');
    });
  }
  
  // Make addToCart globally available for Buy Now functionality
  window.addToCart = addToCart;

  // Handle add to cart buttons
  document.addEventListener('click', function(e) {
    if (e.target.closest('.add-to-cart-btn')) {
      e.preventDefault();
      const button = e.target.closest('.add-to-cart-btn');
      const variantId = button.dataset.variantId;
      
      // Check if there's a quantity input on the page (product page)
      const quantityInput = document.getElementById('quantity-input');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : (button.dataset.quantity || 1);
      
      if (variantId) {
        addToCart(variantId, quantity);
      }
    }
  });

  // ===================================
  // Update Cart UI
  // ===================================
  function updateCartUI() {
    fetch(window.theme.routes.cart_url + '.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart count
        const cartCounts = document.querySelectorAll('.cart-count');
        cartCounts.forEach(count => {
          count.textContent = cart.item_count;
          count.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        // Update cart items
        updateCartItems(cart);
      })
      .catch(error => console.error('Error updating cart:', error));
  }

  // Build cart item image HTML similar to Liquid fallback logic
  function getCartItemImageHTML(item) {
    if (item && item.image) {
      // Try to request a smaller rendition when possible
      try {
        const resized = item.image.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\\?.*)?$/i, (_m, ext) => `_100x${ext}`);
        return `<img src="${resized}" alt="${item.title}">`;
      } catch (_e) {
        const url = item.image.includes('?') ? `${item.image}&width=100` : `${item.image}?width=100`;
        return `<img src="${url}" alt="${item.title}">`;
      }
    }
    const title = (item.product_title || item.title || '').toLowerCase();
    const box = (emoji, gradient) =>
      `<div style="width: 80px; height: 80px; background: ${gradient}; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 2rem;">${emoji}</div>`;
    if (title.includes('starter') || title.includes('basic')) {
      return box('🚀', 'linear-gradient(135deg, #10B981, #06B6D4)');
    } else if (title.includes('pro') || title.includes('task')) {
      return box('⚡', 'linear-gradient(135deg, #3B82F6, #8B5CF6)');
    } else if (title.includes('business automation')) {
      return box('💼', 'linear-gradient(135deg, #7C3AED, #EC4899)');
    } else if (title.includes('business') || title.includes('suite')) {
      return box('🏆', 'linear-gradient(135deg, #F59E0B, #F97316)');
    } else if (title.includes('ecommerce') || title.includes('e-commerce')) {
      return box('🛒', 'linear-gradient(135deg, #EF4444, #F59E0B)');
    } else if (title.includes('social') || title.includes('media')) {
      return box('📣', 'linear-gradient(135deg, #06B6D4, #0EA5E9)');
    } else if (title.includes('analytics') || title.includes('tracking')) {
      return box('📊', 'linear-gradient(135deg, #8B5CF6, #06B6D4)');
    } else if (title.includes('content') || title.includes('seo')) {
      return box('✍️', 'linear-gradient(135deg, #F472B6, #6366F1)');
    } else if (title.includes('crm') || title.includes('leads')) {
      return box('👥', 'linear-gradient(135deg, #10B981, #3B82F6)');
    } else if (title.includes('security') || title.includes('secure')) {
      return box('🛡️', 'linear-gradient(135deg, #10B981, #059669)');
    } else if (title.includes('training')) {
      return box('🎓', 'linear-gradient(135deg, #F59E0B, #EF4444)');
    } else if (title.includes('api') || title.includes('developer')) {
      // This matches the product with the plug icon
      return box('🔌', 'linear-gradient(135deg, #6366F1, #8B5CF6)');
    }
    return box('✨', 'linear-gradient(135deg, #7C3AED, #3B82F6)');
  }

  function updateCartItems(cart) {
    const cartItemsContainer = document.querySelector('.cart-items');
    const cartEmpty = document.querySelector('.cart-empty');
    const cartFooter = document.querySelector('.cart-footer');
    
    if (!cartItemsContainer) return;

    if (cart.items.length === 0) {
      if (cartEmpty) cartEmpty.style.display = 'block';
      if (cartFooter) cartFooter.style.display = 'none';
      cartItemsContainer.innerHTML = '';
      return;
    }

    if (cartEmpty) cartEmpty.style.display = 'none';
    if (cartFooter) cartFooter.style.display = 'block';

    cartItemsContainer.innerHTML = cart.items.map((item, index) => `
      <div class="cart-item" data-line="${index + 1}">
        <div class="cart-item-image">
          ${getCartItemImageHTML(item)}
        </div>
        <div class="cart-item-details">
          <div class="cart-item-title">${item.product_title}</div>
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-item-quantity">
            <button class="btn-icon cart-qty-btn" data-line="${index + 1}" data-quantity="${item.quantity - 1}">-</button>
            <span>${item.quantity}</span>
            <button class="btn-icon cart-qty-btn" data-line="${index + 1}" data-quantity="${item.quantity + 1}">+</button>
            <button class="cart-remove-btn" data-line="${index + 1}">Remove</button>
          </div>
        </div>
      </div>
    `).join('');

    // Update cart total
    const cartTotalElement = document.querySelector('.cart-total-amount');
    if (cartTotalElement) {
      cartTotalElement.textContent = formatMoney(cart.total_price);
    }
  }

  // Handle cart quantity changes
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cart-qty-btn')) {
      const button = e.target.closest('.cart-qty-btn');
      const line = button.dataset.line;
      const quantity = parseInt(button.dataset.quantity);
      
      if (quantity >= 0) {
        updateCartQuantity(line, quantity);
      }
    }

    if (e.target.closest('.cart-remove-btn')) {
      const button = e.target.closest('.cart-remove-btn');
      const line = button.dataset.line;
      updateCartQuantity(line, 0);
    }
  });

  function updateCartQuantity(line, quantity) {
    fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      updateCartUI();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
  }

  // ===================================
  // Notification System
  // ===================================
  function showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 100px;
      right: 20px;
      background: ${type === 'success' ? '#10b981' : '#ef4444'};
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.2);
      z-index: 9999;
      animation: slideInRight 0.3s ease;
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // ===================================
  // Money Formatting
  // ===================================
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return window.theme.moneyFormat.replace('{{amount}}', amount);
  }

  // ===================================
  // Animated Counter
  // ===================================
  function animateCounter(element, target, duration = 2000) {
    const start = 0;
    const startTime = performance.now();
    
    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      const current = Math.floor(progress * target);
      element.textContent = current + (element.dataset.suffix || '');
      
      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }
    
    requestAnimationFrame(update);
  }

  // Animate counters on scroll
  const counters = document.querySelectorAll('.hero-stat-value');
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
        entry.target.classList.add('animated');
        const target = parseInt(entry.target.dataset.value || entry.target.textContent);
        animateCounter(entry.target, target);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => counterObserver.observe(counter));

  // ===================================
  // Initialize Cart on Page Load
  // ===================================
  document.addEventListener('DOMContentLoaded', function() {
    updateCartUI();
  });

  // ===================================
  // Active Navigation Link
  // ===================================
  const currentPath = window.location.pathname;
  const navLinks = document.querySelectorAll('.nav-link');
  
  navLinks.forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

})();


